import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=204316b0&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"
import style0 from "./AddDocument.vue?vue&type=style&index=0&id=204316b0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204316b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204316b0')) {
      api.createRecord('204316b0', component.options)
    } else {
      api.reload('204316b0', component.options)
    }
    module.hot.accept("./AddDocument.vue?vue&type=template&id=204316b0&scoped=true", function () {
      api.rerender('204316b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/documentConfiguration/components/AddDocument.vue"
export default component.exports